import * as types from './../types/matCanvas';

export const setCanvas = (payload) => ({
	type: types.SET_CANVAS,
	payload,
});
